module.exports = __webpack_public_path__ + "transfer_3.bfaa4467afdf5662e0fb5410e495d879.svg";